import { SpinnerProps } from './types';

import * as S from './styles';

const Spinner = (props: SpinnerProps) => (
  <S.Spinner viewBox="0 0 50 50" {...props}>
    <circle
      className="path"
      cx="25"
      cy="25"
      r="20"
      fill="none"
      strokeWidth="4"
    />
  </S.Spinner>
);

export default Spinner;
